import { MetricsDashboard } from "@/MetricsDashboard";

import { useDeviceContext } from "../Device/useDeviceContext";

import styles from "./DeviceMetrics.module.css";

/**
 * Body of the Metrics tab on the device-detail page. Mounted only when
 * `featureFlagRoute` in `DevicesRoutes` admits
 * `/devices/:deviceId/metrics` under the `release-metrics` flag.
 *
 * Renders the shared `MetricsDashboard` scoped to this device. The dashboard
 * itself handles loading/empty/error states.
 */
export function DeviceMetrics() {
  const { deviceId, org } = useDeviceContext();

  return (
    <div className={styles.container}>
      <MetricsDashboard orgId={org?.org_id} deviceId={deviceId} />
    </div>
  );
}
